export const CATGORY_LABEL = "Category Name";
export const CATEGORY_NAME = "categoryName";
export const CATEGORY_DESC_LABEL = "Category Description";
export const CATEGORY_DESC_NAME = "caetegoryDescName";
export const CATEGORY_NAME_LABEL_FR = "Category Name (French)";
export const CATEGORY_NAME_FR = "categoryFrName";
export const CATGEORY_DESC_FR_LABEL = "Category Description (French)";
export const CATEGORY_DESC_FR_NAME = "categoryDescFrName";
